// Editează aceste valori după ce primești detaliile finale.
// Apar în Politica de confidențialitate, Politica de cookies, Termeni și condiții.

export const COMPANY = {
  legalName: "SC Smart Creative Advertising SRL",
  cui: "RO31185782",
  regCom: "J2013001401400",
  address: "Drumul Gura Putnei nr. 151, Camera 3, Et. 1, Ap. 10, Sector 3",
  city: "București",
  postalCode: "032603",
  country: "România",
  email: "hello@c2advertising.ro",
  dpoEmail: "hello@c2advertising.ro",
  phone: "0727 014 425",
  website: "c2advertising.ro",
  domain: "https://c2advertising.ro",
  // Data ultimei actualizări a documentelor legale
  legalLastUpdated: "iunie 2026",
};
